module.exports = __webpack_public_path__ + "img/oil_refinery.c31fc868.jpg";